import React from 'react';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { theme } from '@picardy/picardy-design-system';

import { useUser } from '../../../common/components/User';

export default function SignupCTA() {
  if (useUser()) return null;

  return (
    <Paper
      elevation={2}
      style={{
        backgroundColor: theme.palette.primary.main,
        margin: '1em 0',
        padding: '1em',
      }}
    >
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <Typography
          style={{ color: theme.palette.grey['100'] }}
          variant="body2"
        >
          Sign up to get full access to Picardy!
        </Typography>

        <Link
          href="/login"
          variant="body2"
          style={{ color: theme.palette.grey['100'], fontWeight: 700 }}
        >
          Sign up
        </Link>
      </Box>
    </Paper>
  );
}
